import React from "react";
import "../Pages/card.scss";

function Card({ img, title, description, alt }) {
  return (
    <div>
      <div className="card__body">
        <img src={img} className="card__image" alt={alt} />
        <h2 className="card__title">{title}</h2>
        <p className="card__description">{description}</p>
      </div>
    </div>
  );
}

export default Card;
